module.exports = __webpack_public_path__ + "img/icon-yellow-clock.0c83c90e.svg";